import Footer from 'components/Footer'
import Header from 'components/Header'
import InputField from 'components/InputField'
import * as React from 'react'
import { Button } from 'react-bootstrap'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { RegisterKind, SummaryDocumentKind, SummaryDocumentStatus } from '../api/common/constants'
import { SummaryDocumentValidationRequest } from '../api/common/requests'
import summaryDocumentValidationAPI from '../api/summaryDocumentValidation'

type LocationState = { isCampaign?: boolean } | null

const SceneComponent: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { type, hash } = useParams()
  // Rev.20 S46: state.isCampaign=true なら CampaignSignUp、それ以外は通常 QR の signUpPreRegisterConnector に遷移
  const isCampaign = ((location.state as LocationState) ?? null)?.isCampaign === true
  const nextUrl = isCampaign ? `/campaignSignUp/${hash}` : `/signUpPreRegisterConnector/${type}/${hash}`
  type DocumentNumber = {
    value: string
    valid: boolean
  }
  const [documentNumbers, setDocumentNumbers] = React.useState<DocumentNumber[]>([{ value: '', valid: true }])
  React.useEffect(() => {
    if (!hash || (type !== RegisterKind.Invite && type !== RegisterKind.Assignment)) {
      navigate('/login')
    }
  })
  const addDocumentNumber = () => {
    setDocumentNumbers([...documentNumbers, { value: '', valid: true }])
  }
  const onChange = (index: number, value: string) => {
    const newDocumentNumbers = [...documentNumbers]
    newDocumentNumbers[index].value = value
    newDocumentNumbers[index].valid = true
    setDocumentNumbers(newDocumentNumbers)
  }
  const onSubmit = async () => {
    const reqParam: SummaryDocumentValidationRequest = {
      documentNumbers: documentNumbers.map((documentNumber) => documentNumber.value),
    }

    await summaryDocumentValidationAPI(reqParam, (status, result) => {
      if (status === 'success') {
        result.forEach((status, index) => {
          if (status !== SummaryDocumentStatus.Valid) {
            const newDocumentNumbers = [...documentNumbers]
            newDocumentNumbers[index].valid = false
            setDocumentNumbers(newDocumentNumbers)
          }
        })
        const isValidAll = result.every((status) => status === SummaryDocumentStatus.Valid)
        if (isValidAll) {
          const summaryDocumentNumbers = documentNumbers.map((documentNumber) => documentNumber.value)
          const formValues = { summaryDocumentKind: SummaryDocumentKind.Paper, summaryDocumentNumbers }
          navigate(nextUrl, { state: { formValues } })
        }
      } else {
        console.log(status)
      }
    })
  }
  return (
    <>
      <Header title="（紙面）概要書面番号入力" />
      <main>
        <section className="mx-4 my-5">
          <p className="fw-bold">概要書面の表紙に記載されている固有の番号をアルファベットからすべて入力してください。</p>
          <form>
            {documentNumbers.map((documentNumber, index) => (
              <InputField
                key={index}
                name={`paper-number-${index}`}
                className="mt-3"
                type="text"
                value={documentNumber.value}
                placeholder="AB12345678"
                ariaLabel="概要書面番号入力"
                bold
                onChange={(e) => onChange(index, e.target.value)}
                errors={documentNumber.valid ? undefined : ['正しい番号を入力してください。']}
              />
            ))}
            <div className="mt-2 text-end">
              <Button variant="link" onClick={addDocumentNumber}>
                さらに追加する
              </Button>
            </div>
            <div className="mt-5">
              <Button variant="primary" className="w-100 py-4" onClick={onSubmit}>
                登録する
              </Button>
            </div>
          </form>
          <div className="mt-4 text-center">
            <Button variant="link" onClick={() => navigate(-1)}>
              概要書面交付方法の選択に戻る
            </Button>
          </div>
        </section>
      </main>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
